import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const MenuIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="hamburger-menu-icon"
    width="24px"
    height="17px"
    viewBox="0 0 24 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 8.5C24 7.88768 23.4801 7.3913 22.8387 7.3913H1.16129C0.519927 7.3913 0 7.88768 0 8.5C0 9.11232 0.519927 9.6087 1.16129 9.6087H22.8387C23.4801 9.6087 24 9.11232 24 8.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 1.1087C24 0.49638 23.4801 0 22.8387 0H1.16129C0.519927 0 0 0.49638 0 1.1087C0 1.72101 0.519927 2.21739 1.16129 2.21739H22.8387C23.4801 2.21739 24 1.72101 24 1.1087Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 15.8913C24 15.279 23.4801 14.7826 22.8387 14.7826H1.16129C0.519927 14.7826 0 15.279 0 15.8913C0 16.5036 0.519927 17 1.16129 17H22.8387C23.4801 17 24 16.5036 24 15.8913Z"
      fill="currentColor"
    />
  </Icon>
);
